import { calculateLorentzianHeight, getLorentzianFactor, lorentzianFwhmToWidth, lorentzianWidthToFWHM, } from "../lorentzian/Lorentzian.js";
export class LorentzianDispersive {
    /**
     * Full width at half maximum.
     * @default 500
     */
    fwhm;
    constructor(options = {}) {
        const { fwhm = 500 } = options;
        this.fwhm = fwhm;
    }
    fwhmToWidth(fwhm = this.fwhm) {
        return lorentzianFwhmToWidth(fwhm);
    }
    widthToFWHM(width) {
        return lorentzianWidthToFWHM(width);
    }
    fct(x) {
        return lorentzianDispersiveFct(x, this.fwhm);
    }
    getArea() {
        return 0;
    }
    getFactor(area) {
        return getLorentzianFactor(area);
    }
    getData(options = {}) {
        return getLorentzianDispersiveData(this, options);
    }
    calculateHeight(area = 1) {
        return calculateLorentzianHeight({ fwhm: this.fwhm, area });
    }
    getParameters() {
        return ['fwhm'];
    }
    derivative(x) {
        const { fct, dx, dFwhm } = lorentzianDispersiveDerivative(x, this.fwhm);
        return { fct, dx, parameters: [dFwhm] };
    }
}
export const lorentzianDispersiveFct = (x, fwhm) => {
    return (2 * fwhm * x) / (4 * x ** 2 + fwhm ** 2);
};
/**
 * Analytical value and partial derivatives of the dispersive lorentzian function centered at x=0.
 * @param x - position at which to evaluate.
 * @param fwhm - full width at half maximum.
 * @returns the value `fct` and its partial derivatives with respect to `x` (`dx`) and `fwhm` (`dFwhm`).
 */
export function lorentzianDispersiveDerivative(x, fwhm) {
    const denominator = 4 * x * x + fwhm * fwhm;
    const fct = (2 * fwhm * x) / denominator;
    const dx = (2 * fwhm * (fwhm * fwhm - 4 * x * x)) / (denominator * denominator);
    const dFwhm = (2 * x * (4 * x * x - fwhm * fwhm)) / (denominator * denominator);
    return { fct, dx, dFwhm };
}
export const getLorentzianDispersiveData = (shape = {}, options = {}) => {
    const { fwhm = 500 } = shape;
    const { factor = getLorentzianFactor(), height = calculateLorentzianHeight({ fwhm, area: 1 }), } = options;
    let { length } = options;
    if (!length) {
        length = Math.min(Math.ceil(fwhm * factor), 2 ** 25 - 1);
        if (length % 2 === 0)
            length++;
    }
    const center = (length - 1) / 2;
    const data = new Float64Array(length);
    for (let i = 0; i <= center; i++) {
        const value = lorentzianDispersiveFct(i - center, fwhm) * height;
        data[i] = value;
        data[length - 1 - i] = -value;
    }
    return data;
};
//# sourceMappingURL=LorentzianDispersive.js.map